import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import {
    getHandleProfileChains,
    getHandleProfileToken,
    getSelectedChain,
    handleFetchPools,
} from 'store/action';
import web3Service from 'util/web3Service.js';
import useCurrentChain from './useCurrentChain';

const UseRefreshHook = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    //Use Selectors
    const {
        ChainListUpdated,
        selectedChain,
        apiStatusTrade,
    } = useSelector((state) => state.Trade);

    const currentChain = useCurrentChain(!!ChainListUpdated);

    const [refreshCount, setRefreshCount] = useState(0);

    const isFetchingError = useMemo(
        () => apiStatusTrade?.length > 0 &&
            process.env.REACT_APP_UPGRADE_MESSAGE !== 'true',
        [apiStatusTrade?.length],
    );

    useEffect(() => {
        if (!isFetchingError) return;
        const ms = Math.min(5000 + refreshCount * 1000, 10000);
        const timer = setTimeout(() => {
            console.log('Force refreshing...');
            setRefreshCount(count => count + 1);
        }, ms);
        return () => clearTimeout(timer);
    }, [isFetchingError, refreshCount]);

    useEffect(() => {
        if (!!ChainListUpdated) return;
        dispatch(getHandleProfileChains());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ChainListUpdated]);

    useEffect(() => {
        if (!currentChain) return;
        localStorage.setItem('lastChainId', currentChain.id);
        web3Service.setAddressesFromChainInfo(currentChain);
        const ChainInfo = {
            chainId1: currentChain,
            chainId2: currentChain,
        };
        if (location.pathname !== '/') dispatch(getSelectedChain({ ...ChainInfo, part: 1 }));
        dispatch(handleFetchPools(currentChain.id));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentChain?.id, refreshCount]);

    useEffect(() => {
        if (!currentChain) return;
        dispatch(getHandleProfileToken({
            ...selectedChain,
            part: undefined,
            fetchBalances: true,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedChain, refreshCount]);

    useEffect(() => {
        if (!currentChain?.id && !isFetchingError) return;
        const qry = queryString.parse(location.search);
        if (qry.chainId != currentChain?.id) {
            if (isFetchingError) localStorage.removeItem('lastChainId');
            const searchStr = '?' + queryString.stringify({
                ...qry,
                chainId: currentChain?.id,
            });
            navigate(searchStr);
        }
    }, [currentChain?.id, location.search, navigate, isFetchingError]);
};
export default UseRefreshHook;
